import {Component, HostListener, OnInit} from '@angular/core';
import {NavigatorService} from '../../services/navigatorService/navigator.service';
import {UserService} from '../../services/api-handlers/userService/user.service';
import {BootstrapNotifyService} from '../../services/bootstrap-notify/bootstrap-notify.service';
import {CacheService} from '../../services/cacheService/cache.service';
import {SharedFormService} from "../../services/shared-form.service";
import {ViewportScroller} from "@angular/common";
declare const $: any;

@Component({
  selector: 'app-sign-up2',
  templateUrl: './sign-up2.component.html',
  styleUrls: ['./sign-up2.component.css']
})
export class SignUp2Component implements OnInit {
  public loading = false;
  pageYoffset = 0;
  public subscribeMail = {
    email: null
  };
  public year: number = new Date().getFullYear();
  @HostListener('window:scroll', ['$event']) onScroll(event) {
    this.pageYoffset = window.pageYOffset;
  }
  constructor(private userService: UserService, private navigatorService: NavigatorService, private scroll: ViewportScroller,
              private cacheService: CacheService,
              private bootstrapService: BootstrapNotifyService, private sharedFormService: SharedFormService, private navigationService: NavigatorService) {
  }

  ngOnInit(): void {
    // this.getLocations();
    // console.log('SignUp2 Page Message', this.sharedFormService.admissionData);
  }

  public subscribeProcess() {
    if (!this.subscribeMail.email) {
      return this.bootstrapService.error('Please Provide your Email Address to Proceed!!');
    } else {
      this.loading = true;
      this.userService.emailSubscribe(this.subscribeMail).subscribe((res: any) => {
        console.log('Subscribe Details', this.subscribeMail);
        this.loading = false;
        setTimeout(() => {
          this.bootstrapService.success(res.message || 'Successful');
        }, 5000);  //5s
      }, error => {
        this.loading = false;
        console.log('Signup Error Data', this.subscribeMail);
        this.bootstrapService.error(error.error.errors, error.error.status);
        /*this.bootstrapService.error(error.status || 'Unable to Process Signup');*/
      });
    }
  }

  scrollToTop() {
    this.scroll.scrollToPosition([0, 0]);
  }

}
